/**
 * GraphQL `__typename` values of everything in the curriculum tree. One
 * namespace, because that is what the field holds - nodes, sections and leaves.
 */
export const CURRICULUM_TYPENAMES = {
  FOLDER: "CurriculumFolder",
  COLLECTION: "Collection",
  SET: "ActivitySet",
  ACTIVITY: "Activity",
  CONTENT_SECTION: "ContentSection",
  QUIZ_QUESTION: "QuizQuestion",
  SURVEYS: "Surveys",
  QUIZ_ANSWER: "QuizAnswer",
  CONTENT_SECTION_GROUP: "ContentSectionGroup",
  NODE_TYPE: "ActivitySetType",
  CERTIFICATE: "Certificate",
};
